import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { KycService } from '../../../../../../shared/services/kyc.service';

export interface KycSelectModel {
    name: string;
    value: string;
    type: string;
    placeholder: string;
}
@Component({
    selector: 'app-kyc-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
})
export class SelectComponent implements OnInit {
    @Input() field: KycSelectModel;
    @Input() isBank: boolean;
    @Input() options;

    @Output() optionChange = new EventEmitter<{}>();

    isActive: boolean;

    banks = [
       
    ];

    emitChange(e) {
        this.isActive = true;
        this.optionChange.emit({
            name: this.field.value,
            value: e.target.value,
        });
    }

    constructor(private api: KycService,) {}

    ngOnInit() {
       this.getBank();
    }

    // fetch all banks
    getBank(){
        this.api.getBank()
            .subscribe((res:any)=>{
                this.banks = res.data;
            })
    }
}
